import { Toggle } from '@ui/themed';
import type { ReactNode } from 'react';
import { SettingRow } from './setting-row';
import { type StaffAccess, useStaffWriteLock } from './staff-setting';

export function SettingToggleRow({
  label,
  description,
  checked,
  onChange,
  mono,
  truncate,
  learnMoreUrl,
  disabled,
  helpText,
  replacement,
  nested,
  staff,
  staffContactTrigger,
}: {
  label: ReactNode;
  description?: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  mono?: boolean;
  truncate?: boolean;
  learnMoreUrl?: string;
  disabled?: boolean;
  helpText?: ReactNode;
  /** Rendered instead of the toggle, e.g. a {@link PlanUpgradePrompt}. */
  replacement?: ReactNode;
  nested?: boolean;
  staff?: StaffAccess;
  /** Intercom trigger for the support link merchants see on `staff="write"` rows. */
  staffContactTrigger?: string;
}) {
  const staffLock = useStaffWriteLock({ staff, contactTrigger: staffContactTrigger });
  const help = helpText ?? staffLock.helpText;

  return (
    <SettingRow
      label={label}
      description={description}
      learnMoreUrl={learnMoreUrl}
      mono={mono}
      truncate={truncate}
      nested={nested}
      staff={staff === 'read-write' ? staff : undefined}
      control={
        <div className="flex flex-col items-end">
          {replacement ?? (
            <Toggle checked={checked} onChange={onChange} disabled={disabled || staffLock.locked} />
          )}
          {help && (
            <div className="mt-2 flex items-center text-spark-text-secondary text-xs">{help}</div>
          )}
        </div>
      }
    />
  );
}
